module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-header"
  }, [_c('div', {
    staticClass: "header-wrapper-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.login) ? _c('div', {
    staticClass: "header-operations"
  }, [_c('div', {
    staticClass: "btn-img close",
    on: {
      "click": _vm.closeAcountAction
    }
  }, [_c('span', {
    staticClass: "iconfont icon-zhuxiao"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-img logout",
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "iconfont icon-tuichu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.logout')))])])]) : _c('div', {
    staticClass: "header-operations"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.info')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/header-logo.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37f60726", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f60726"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 46
// module chunks = 1 2 3 4 6